export default function about() {

  $('.team-members').owlCarousel({
    items: 1,
    autoplay: false,
    loop: true,
    smartSpeed: 800,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    mouseDrag: true,
    touchDrag: true,
    nav: false,
    autoWidth: true,
    responsive: {
      767: {
        items: 3
      },
      992: {
        items: 3,
        mouseDrag: false,
        touchDrag: false,
        autoWidth: false
      }
    }
  });
	
}